import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { AuthService } from 'app/services/auth/auth.service';
import { PermissionsService } from '../../services/permissions/permissions.service';

/** Lets a route through only when the user holds the permission in `route.data.permission`. */
@Injectable({
  providedIn: 'root'
})
export class PermissionGuard implements CanActivate {
  constructor(
    private readonly permissionsService: PermissionsService,
    private readonly router: Router,
    private readonly authService: AuthService
  ) {}

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean | UrlTree> {
    // Required, do not remove: initial navigation and the auth app initializer run concurrently.
    await this.authService.ready;

    const permission: string | undefined = route.data?.['permission'];
    if (!permission) {
      return true;
    }

    await this.permissionsService.ensurePermissionsLoaded();
    return this.permissionsService.hasPermission(permission) || this.router.createUrlTree(['/no-access']);
  }
}
